import { CashMarkerIcon } from './CashMarkerIcon';

/**
 * author: Michael Irigoyen
 * id 080E0DBC-A7E4-40C0-A126-9CE83BDE2FDF
 * name cash-marker
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-marker.svg
 * tags
 * - Banking 
 * - Currency 
 * - Navigation 
 */
export const CodIcon = CashMarkerIcon;
export default CodIcon